module.exports = "<div class=\"main-panel\">\r\n    <router-outlet></router-outlet>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main